function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Tooltip from '@homeaway/react-tooltip';
import { SVGIcon } from '@homeaway/react-svg';
import { SUCCESS__16 } from '@homeaway/svg-defs';
import { Divider } from '@homeaway/react-collapse';
import { renderPropValue } from '../../utils/renderPropEventValues';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import "./PropDocs.css";

var PropDocs = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PropDocs, _Component);

  function PropDocs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      expanded: _this.props.expanded,
      parentNode: _this.parentNode
    };

    _this.handleExpandedChange = function (isExpanded) {
      _this.setState({
        expanded: isExpanded
      });
    };

    _this.renderHeading = function () {
      return (_this.state.expanded ? 'Hide' : 'View') + " Properties Table";
    };

    return _this;
  }

  var _proto = PropDocs.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      // eslint-disable-line react/no-did-mount-set-state
      parentNode: document.getElementsByTagName('body')[0]
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        componentName = _this$props.componentName,
        expanded = _this$props.expanded;
    var parentNode = this.state.parentNode;
    return /*#__PURE__*/React.createElement(Divider, {
      onExpandedChange: this.handleExpandedChange,
      expanded: expanded,
      heading: this.renderHeading(),
      id: componentName + "-properties-table-divider"
    }, /*#__PURE__*/React.createElement("div", {
      className: "PropDocs"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "0",
      height: "0",
      style: {
        display: 'none'
      },
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
      id: "svg-alert-check",
      viewBox: "0 0 50 50"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M25 .4C11.4.4.4 11.4.4 25c0 13.6 11 24.6 24.6 24.6 13.6 0 24.6-11 24.6-24.6C49.6 11.4 38.6.4 25 .4zm-.4 35.2L14.3 25.2l2-2 7.6 7.5 9-16.3 2.7 1.5-11 19.6z"
    })))), /*#__PURE__*/React.createElement("table", {
      className: "PropDocs__table table table-hover"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      className: "PropDocs__th"
    }, 'Property'), /*#__PURE__*/React.createElement("th", {
      className: "PropDocs__th"
    }, 'Type'), /*#__PURE__*/React.createElement("th", {
      className: "PropDocs__th"
    }, 'Default'), /*#__PURE__*/React.createElement("th", {
      className: "PropDocs__th"
    }, 'Description'))), /*#__PURE__*/React.createElement("tbody", null, this.props.properties.sort(function (propA, propB) {
      return propB.required - propA.required;
    }).map(function (prop) {
      var thClassNames = classnames({
        'bg--color-neutral-lighter': prop.required
      });
      return /*#__PURE__*/React.createElement("tr", {
        className: thClassNames,
        key: "row-" + prop.name
      }, /*#__PURE__*/React.createElement("td", {
        className: "PropDocs__td PropDocs__td--monospace PropDocs__td--name"
      }, /*#__PURE__*/React.createElement("span", {
        className: "PropDocs__td--name"
      }, prop.name), prop.required && /*#__PURE__*/React.createElement("span", {
        className: "PropDocs__Tooltip"
      }, /*#__PURE__*/React.createElement(Tooltip, {
        parentNode: parentNode,
        centered: true,
        content: "Required"
      }, /*#__PURE__*/React.createElement(SVGIcon, {
        markup: SUCCESS__16,
        inlineFlex: true,
        className: "PropDocs__required-icon text-success"
      })))), prop.type && prop.type.value && /*#__PURE__*/React.createElement("td", {
        className: "PropDocs__td PropDocs__td--monospace PropDocs__td--type"
      }, renderPropValue(prop.type.value.join(', '), false, parentNode)), (!prop.type || !prop.type.value) && /*#__PURE__*/React.createElement("td", {
        className: "PropDocs__td PropDocs__td--monospace PropDocs__td--type"
      }), /*#__PURE__*/React.createElement("td", {
        className: "PropDocs__td PropDocs__td--monospace PropDocs__td--default"
      }, prop.defaultValue && prop.defaultValue.value ? renderPropValue(prop.defaultValue.value, false, parentNode) : '──'), /*#__PURE__*/React.createElement("td", {
        className: "PropDocs__td PropDocs__td--description PropDocs__td--last-child"
      }, prop.description));
    })))));
  };

  return PropDocs;
}(Component);

PropDocs.propTypes = {
  /** Expand or collapse by default */
  expanded: PropTypes.bool,

  /** Name of component */
  componentName: PropTypes.string,

  /** The properties to document. */
  properties: PropTypes.arrayOf(PropTypes.shape({
    defaultValue: PropTypes.shape({
      computed: PropTypes.bool,
      value: PropTypes.string
    }),
    description: PropTypes.string,
    name: PropTypes.string,
    required: PropTypes.bool,
    type: PropTypes.shape({
      value: PropTypes.arrayOf(PropTypes.string)
    })
  }))
};
PropDocs.defaultProps = {
  properties: [],
  expanded: true
};
export default PropDocs;
//# sourceMappingURL=PropDocs.js.map